import {
  AssignEmployeesSchema,
  AssignEmployeesSchemaType,
} from 'modules/shift_management/lib/forms/AssignEmployees/schema'

const Form = () => {
  const defaultValues: AssignEmployeesSchemaType = {
    employeeSelection: { type: 'manual', ids: [] },
  }

  return {
    defaultValues,
    schema: AssignEmployeesSchema(),
  }
}

export { Form }
